module.exports = __webpack_public_path__ + "static/media/driving.53486c3e.png";